module.exports = __webpack_public_path__ + "img/export.3556643a.svg";